<script lang="ts">
import { Avatar as AvatarPrimitive } from 'bits-ui';
import type { Snippet } from 'svelte';

let {
  delayMs = 0,
  children,
  ...restProps
}: AvatarPrimitive.RootProps & { children?: Snippet } = $props();
</script>

<AvatarPrimitive.Root
  {delayMs}
  style="position: relative; display: inline-flex; flex-shrink: 0; overflow: hidden; border-radius: 50%; width: 28px; height: 28px;"
  {...restProps}
>
  {@render children?.()}
</AvatarPrimitive.Root>
